import React, { useEffect } from 'react';
import Footer from '../../Footer/Footer';
import Header from '../../Header/Header';
import grievanceFlowchart from '../../../../assets/img/grievances_stage.png';

const CheckIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		style={{ flexShrink: 0, width: 24, height: 24, color: '#16a34a', marginTop: 2 }}
	>
		<path d="M21.801 10A10 10 0 1 1 17 3.335" />
		<path d="m9 11 3 3L22 4" />
	</svg>
);

const AlertIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		style={{ flexShrink: 0, width: 24, height: 24, color: '#ca8a04', marginTop: 2 }}
	>
		<circle cx="12" cy="12" r="10" />
		<line x1="12" x2="12" y1="8" y2="12" />
		<line x1="12" x2="12.01" y1="16" y2="16" />
	</svg>
);

const s = {
	page: { minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f9fafb' },
	hero: { backgroundColor: '#335EEA', color: '#fff', padding: '40px 0' },
	heroInner: { maxWidth: 1152, margin: '0 auto', padding: '0 24px' },
	heroTitle: { fontSize: '2rem', fontWeight: 700, marginBottom: 8 },
	heroSub: { fontSize: '1rem', color: '#bfdbfe', maxWidth: 800 },
	section: (bg) => ({ padding: '64px 0', backgroundColor: bg || '#fff' }),
	inner: { maxWidth: 1152, margin: '0 auto', padding: '0 24px' },
	sectionTitle: { fontSize: '1.875rem', fontWeight: 700, color: '#111827', marginBottom: 32 },
	rightItem: { display: 'flex', gap: 16, marginBottom: 24 },
	rightText: { flex: 1 },
	rightHeading: { fontWeight: 600, color: '#111827', marginBottom: 4 },
	rightDesc: { color: '#374151', margin: 0 },
	stepWrap: { marginBottom: 48 },
	stepHeader: { display: 'flex', gap: 16, marginBottom: 16, alignItems: 'flex-start' },
	stepBadge: {
		flexShrink: 0,
		width: 40,
		height: 40,
		borderRadius: '50%',
		backgroundColor: '#335EEA',
		color: '#fff',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontWeight: 700,
		fontSize: '1rem',
	},
	stepTitle: { fontSize: '1.25rem', fontWeight: 600, color: '#111827', margin: 0 },
	stepSub: { fontSize: '0.875rem', color: '#6b7280', margin: '4px 0 0' },
	stepBody: {
		marginLeft: 56,
		backgroundColor: '#eef1fd',
		padding: 24,
		borderRadius: 8,
	},
	stepBodyText: { color: '#374151', marginBottom: 16 },
	methodLabel: { fontWeight: 600, color: '#111827', marginBottom: 8 },
	ul: { listStyle: 'disc', paddingLeft: 24, color: '#374151', margin: 0 },
	li: { marginBottom: 4 },
	note: { fontSize: '0.875rem', color: '#6b7280', fontStyle: 'italic', marginTop: 16 },
	divider: { borderTop: '1px solid #c5cef9', margin: '24px 0' },
	table: {
		width: '100%',
		backgroundColor: '#fff',
		borderRadius: 8,
		overflow: 'hidden',
		boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
		borderCollapse: 'collapse',
	},
	thead: { backgroundColor: '#335EEA' },
	th: { padding: '16px 24px', textAlign: 'left', color: '#fff', fontWeight: 600 },
	td: { padding: '16px 24px', color: '#374151' },
	tdBold: { padding: '16px 24px', fontWeight: 500, color: '#111827' },
	trAlt: { backgroundColor: '#f9fafb' },
	alertBox: {
		backgroundColor: '#fefce8',
		borderLeft: '4px solid #facc15',
		padding: 24,
		borderRadius: 4,
	},
	alertInner: { display: 'flex', gap: 16 },
	alertTitle: { fontWeight: 600, color: '#111827', marginBottom: 12 },
	alertUl: { listStyle: 'disc', paddingLeft: 24, color: '#374151', margin: 0 },
	link: { color: '#335EEA' },
};

const Grievance = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<Header />

			<div style={s.page}>
				{/* Hero */}
				<section style={s.hero}>
					<div style={s.heroInner}>
						<h1 style={s.heroTitle}>Support &amp; Grievance Redressal</h1>
						<p style={s.heroSub}>
							We take your complaints seriously. Follow these steps to register your concern and
							escalate it to resolution.
						</p>
					</div>
				</section>

				{/* Complainant Rights */}
				<section style={s.section('#fff')}>
					<div style={s.inner}>
						<h2 style={s.sectionTitle}>Complainant Rights</h2>
						<div className="row">
							<div className="col-12 col-md-6">
								<div style={s.rightItem}>
									<CheckIcon />
									<div style={s.rightText}>
										<p style={s.rightHeading}>Acknowledgement at Every Stage</p>
										<p style={s.rightDesc}>
											You will receive an acknowledgement at every stage of your complaint.
										</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-6">
								<div style={s.rightItem}>
									<CheckIcon />
									<div style={s.rightText}>
										<p style={s.rightHeading}>Timely Resolution</p>
										<p style={s.rightDesc}>
											Complaints will be resolved within RBI-mandated timelines at each stage.
										</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-6">
								<div style={s.rightItem}>
									<CheckIcon />
									<div style={s.rightText}>
										<p style={s.rightHeading}>Further Escalation</p>
										<p style={s.rightDesc}>
											Complaints unresolved using the 3-step process stated here can be escalated
											to Appellate Authority or Consumer Forum.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* How to Register */}
				<section style={s.section('#fff')}>
					<div style={s.inner}>
						<h2 style={{ ...s.sectionTitle, marginBottom: 48 }}>How to Register a Complaint</h2>

						{/* Step 1 */}
						<div style={s.stepWrap}>
							<div style={s.stepHeader}>
								<div style={s.stepBadge}>1</div>
								<div>
									<p style={s.stepTitle}>Support Desk</p>
									<p style={s.stepSub}>Initial complaint registration</p>
								</div>
							</div>
							<div style={s.stepBody}>
								<p style={s.stepBodyText}>
									Customers can lodge a complaint with customer support first.
								</p>
								<p style={s.methodLabel}>Method:</p>
								<ul style={s.ul}>
									<li style={s.li}>Email: support@cookiejar.co.in</li>
								</ul>
								<br />
								<p style={s.methodLabel}>What to include in your complaint:</p>
								<ul style={s.ul}>
									<li style={s.li}>Name and contact details</li>
									<li style={s.li}>Detailed issue description</li>
									<li style={s.li}>Supporting documents (screenshots, emails, transaction IDs)</li>
								</ul>
								<p style={s.note}>
									Company will send (auto or manual) acknowledgement within 24 hrs. We will aim to
									resolve the issues within 10 days.
								</p>
							</div>
						</div>

						{/* Step 2 */}
						<div style={s.stepWrap}>
							<div style={s.stepHeader}>
								<div style={s.stepBadge}>2</div>
								<div>
									<p style={s.stepTitle}>Grievance Redressal Officer</p>
									<p style={s.stepSub}>If unresolved within 10 days</p>
								</div>
							</div>
							<div style={s.stepBody}>
									<p style={{ ...s.methodLabel, margin: 0 }}>
										Grievance Redressal Officer: Mr Jaipreet Singh Chhatwal
									</p>
								<p style={s.stepBodyText}>
									If the complaint is not addressed satisfactorily through customer support within
									10 days, escalate to us using any of the following methods:
								</p>
								<p style={s.methodLabel}>Method:</p>
								<ul style={s.ul}>
									<li style={s.li}>Email: grievance@cookiejar.co.in</li>
								</ul>
								<br />
								<p style={s.methodLabel}>Method:</p>
								<ul style={s.ul}>
									<li style={s.li}>Phone: +91 9049040366</li>
								</ul>
								<br />
								<p style={s.methodLabel}>Method:</p>
								<ul style={s.ul}>
									<li style={s.li}>
										Send a written complaint to our corporate address: Cookiejar Technologies Pvt
										Ltd (Finvu), WeWork Raheja Woods, 1st floor, next to Talera Park Society,
										Kalyani Nagar, Pune, Maharashtra, India, 411006
									</li>
								</ul>
								<br />
								<p style={s.methodLabel}>What to include in your complaint:</p>
								<ul style={s.ul}>
									<li style={s.li}>Name and contact details</li>
									<li style={s.li}>Date of event</li>
									<li style={s.li}>Mobile number registered with Finvu</li>
									<li style={s.li}>Customer's Finvu account handle</li>
									<li style={s.li}>Detailed issue description</li>
									<li style={s.li}>Supporting documents (screenshots, emails, transaction IDs)</li>
								</ul>
								<p style={s.note}>
									Company will ensure that the complaint/grievance is resolved within 20 days,
									subject to receipt of proper information from the customer. Any delay will be
									communicated to the customer.
								</p>
							</div>
						</div>

						{/* Step 3 */}
						<div style={s.stepWrap}>
							<div style={s.stepHeader}>
								<div style={s.stepBadge}>3</div>
								<div>
									<p style={s.stepTitle}>RBI Ombudsman</p>
									<p style={s.stepSub}>Final resolution authority</p>
								</div>
							</div>
							<div style={s.stepBody}>
								<p style={s.stepBodyText}>
									If your complaint remains unresolved or no satisfactory redressal is provided
									after 30 days of the initial complaint, you can lodge your complaint with the RBI
									Ombudsman using any of the following methods.
								</p>
								<p style={s.methodLabel}>Method:</p>
								<ul style={s.ul}>
									<li style={s.li}>Email: cgmincdnbsco@rbi.org.in</li>
								</ul>
								<br />
								<p style={s.methodLabel}>Method:</p>
								<ul style={s.ul}>
									<li style={s.li}>
										RBI's Complaint Management System at{' '}
										<a
											href="https://cms.rbi.org.in/cms/indexpage.html#eng"
											target="_blank"
											rel="noopener noreferrer"
											style={s.link}
										>
											RBI CMS
										</a>
										<ul style={{ ...s.ul, marginTop: 8 }}>
											<li style={s.li}>
												This is a free mechanism under the RBI's Complaint Management System
												(CMS). Complaints should be filed within the stipulated RBI timelines.
											</li>
										</ul>
									</li>
								</ul>
								<br />
								<p style={s.methodLabel}>Method:</p>
								<ul style={s.ul}>
									<li style={s.li}>
										Send a written complaint to Shri Sathyan David, Chief General Manager, Reserve
										Bank of India
									</li>
									<li style={s.li}>
										Address: Department of Non-Banking Supervision, Central Office, World Trade
										Centre, Centre 1, 2nd Floor, Cuffe Parade, Colaba, Mumbai- 400005
									</li>
								</ul>
								<br />
								<p style={s.methodLabel}>What to include in your complaint:</p>
								<ul style={s.ul}>
									<li style={s.li}>Name and contact details</li>
									<li style={s.li}>Date of event</li>
									<li style={s.li}>Mobile number registered with Finvu</li>
									<li style={s.li}>Customer's Finvu account handle</li>
									<li style={s.li}>Detailed issue description</li>
									<li style={s.li}>Details of previous communication from Finvu</li>
									<li style={s.li}>Supporting documents (screenshots, emails, transaction IDs)</li>
								</ul>
							</div>
						</div>
					</div>
				</section>

				{/* Turnaround Time Table */}
				<section style={s.section('#f9fafb')}>
					<div style={s.inner}>
						<h2 style={s.sectionTitle}>Expected Turnaround Time</h2>
						<div style={{ overflowX: 'auto' }}>
							<table style={s.table}>
								<thead style={s.thead}>
									<tr>
										<th style={s.th}>Stage</th>
										<th style={s.th}>Max Resolution Time</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td style={s.tdBold}>Support Response</td>
										<td style={s.td}>10 days</td>
									</tr>
									<tr style={s.trAlt}>
										<td style={s.tdBold}>Grievance Officer</td>
										<td style={s.td}>20 days on escalation</td>
									</tr>
									<tr>
										<td style={s.tdBold}>RBI Ombudsman</td>
										<td style={s.td}>As per CMS process &amp; rules</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>

				{/* Flowchart */}
				<section style={s.section('#fff')}>
					<div style={s.inner}>
						<div style={{ textAlign: 'center', marginBottom: 48 }}>
							<h2 style={{ ...s.sectionTitle, marginBottom: 12 }}>Grievance Redressal Process</h2>
							<p style={{ fontSize: '1.125rem', color: '#6b7280', maxWidth: 640, margin: '0 auto' }}>
								Follow the outlined steps for timely and effective issue resolution.
							</p>
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								backgroundColor: '#f9fafb',
								padding: 16,
								borderRadius: 8,
								overflowX: 'auto',
							}}
						>
							<img
								src={grievanceFlowchart}
								alt="Grievance resolution flowchart showing the process from complaint registration to RBI Ombudsman"
								style={{ width: '50%', height: '90vh', maxWidth: 896, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
							/>
						</div>
					</div>
				</section>

				{/* Important Notes */}
				<section style={s.section('#fff')}>
					<div style={s.inner}>
						<h2 style={s.sectionTitle}>Important Notes</h2>
						<div style={s.alertBox}>
							<div style={s.alertInner}>
								<AlertIcon />
								<div>
									<p style={s.alertTitle}>RBI Compliance &amp; Your Protection</p>
									<ul style={s.alertUl}>
										<li style={s.li}>
											Account Aggregators are required to acknowledge and resolve complaints
											promptly under RBI guidelines.
										</li>
										<li style={s.li}>
											This grievance redressal mechanism complies with the Reserve Bank of India's
											Master Directions and Customer Service Guidelines.
										</li>
										<li style={s.li}>
											All information provided during the complaint process is treated with
											confidentiality.
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>

			<Footer />
		</>
	);
};

export default Grievance;
